import React, { useRef } from 'react';

import { Container, Row, Col } from 'reactstrap';
import { Link, NavLink } from 'react-router-dom';
import './header.css';

const navLinks = [
	{
    id: 1,
		path: '/home',
		display: 'Home',
	},
	{
    id: 2,
		path: '/about',
		display: 'About',
	},
	{
    id: 3,
		path: '/cars',
		display: 'Cars',
	},

	{
    id: 4,
		path: '/blogs',
		display: 'Blog',
	},
	{
    id: 5,
		path: '/contact',
		display: 'Contact',
	},
];

const Header = () => {
	const menuRef = useRef(null);

	const toggleMenu = () => menuRef.current.classList.toggle('menu__active');

	return (
		<header className='header'>
			{/* ============ header top ============ */}
			<div className='header__top'>
				<Container>
					<Row>
						<Col lg='6' md='6' sm='6'>
							<div className='header__top__left'>
								<span>Need Help?</span>
								<span className='header__top__help'>
									<i class='ri-phone-fill'></i> +1-202-555-0149
								</span>
							</div>
						</Col>

						<Col lg='6' md='6' sm='6'>
							<div className='header__top__right d-flex align-items-center justify-content-end gap-3'>
								<Link to='#' className=' d-flex align-items-center gap-1'>
									<i class='ri-login-circle-line'></i> Login
								</Link>

								<Link to='#' className=' d-flex align-items-center gap-1'>
									<i class='ri-user-line'></i> Register
								</Link>
							</div>
						</Col>
					</Row>
				</Container>
			</div>

			{/* =============== header middle =========== */}
			<div className='header__middle'>
				<Container>
					<Row>
						<Col lg='4' md='3' sm='4'>
							<div className='logo'>
								<h1>
									<Link to='/home' className=' d-flex align-items-center gap-2'>
										<i class='ri-car-line'></i>
										<span>
											Drive Cars <br /> Service
										</span>
									</Link>
								</h1>
							</div>
						</Col>

						<Col lg='3' md='3' sm='4'>
							<div className='header__location d-flex align-items-center gap-2'>
								<span>
									<i class='ri-earth-line'></i>
								</span>
								<div className='header__location-content'>
									<h4>Algeria</h4>
									<h6>Oran City, Algeria</h6>
								</div>
							</div>
						</Col>

						<Col lg='3' md='3' sm='4'>
							<div className='header__location d-flex align-items-center gap-2'>
								<span>
									<i class='ri-time-line'></i>
								</span>
								<div className='header__location-content'>
									<h4>Sunday to Friday</h4>
									<h6>10am - 7pm</h6>
								</div>
							</div>
						</Col>

						<Col
							lg='2'
							md='3'
							sm='0'
							className=' d-flex align-items-center justify-content-end '
						>
							<button className='header__btn btn'>
								<Link to='/contact'>
									<i class='ri-phone-line'></i> Request a call
								</Link>
							</button>
						</Col>
					</Row>
				</Container>
			</div>

			{/* ========== main navigation =========== */}

			<nav className='main__navbar'>
				<Container>
					<div className='navigation__wrapper d-flex align-items-center justify-content-between'>
						<span className='mobile__menu'>
							<i class='ri-menu-line' onClick={toggleMenu}></i>
						</span>

						<div className='navigation' ref={menuRef}>
							<div className='menu'>
								<span className='mobile__menu-close'>
									<i class='ri-close-line' onClick={toggleMenu}></i>
								</span>
								{navLinks.map(({ path, display, id }) => (
									<NavLink
										to={path}
										className={(navClass) =>
											navClass.isActive ? 'nav__active nav__item' : 'nav__item'
										}
										key={id}
									>
										{display}
									</NavLink>
								))}
							</div>
						</div>

						<div className='nav__right'>
							<div className='search__box'>
								<input type='text' placeholder='Search' />
								<span>
									<i class='ri-search-line'></i>
								</span>
							</div>
						</div>
					</div>
				</Container>
			</nav>
		</header>
	);
};

export default Header;
